import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    offersDetail: `${APP_CONFIG.care_cluster}/orders-360/orders`,
  },
}
